export const beb_yearly_maintenance_cost_index: any = {
  '2022': '1',
  '2023': '0.9756',
  '2024': '0.9512',
  '2025': '0.9268',
  '2026': '0.9024',
  '2027': '0.878',
  '2028': '0.8536',
  '2029': '0.8292',
  '2030': '0.8048',
  '2031': '0.7804',
  '2032': '0.756',
  '2033': '0.7316',
  '2034': '0.7072',
  '2035': '0.6828',
  '2036': '0.6584',
  '2037': '0.634',
  '2038': '0.634',
  '2039': '0.634',
  '2040': '0.634',
  '2041': '0.634',
  '2042': '0.634',
  '2043': '0.634',
  '2044': '0.634',
  '2045': '0.634',
  '2046': '0.634',
  '2047': '0.634',
  '2048': '0.634',
  '2049': '0.634',
  '2050': '0.634',
  '2051': '0.634',
  '2052': '0.634',
  '2053': '0.634',
  '2054': '0.634',
  '2055': '0.634',
  '2056': '0.634',
  '2057': '0.634',
  '2058': '0.634',
  '2059': '0.634',
  '2060': '0.634',
  '2061': '0.634',
}

export const diesel_yearly_maintenance_cost_index: any = {
  '2022': '1.00',
  '2023': '1.00',
  '2024': '1.00',
  '2025': '1.00',
  '2026': '1.00',
  '2027': '1.00',
  '2028': '1.00',
  '2029': '1.00',
  '2030': '1.00',
  '2031': '1.00',
  '2032': '1.00',
  '2033': '1.00',
  '2034': '1.00',
  '2035': '1.00',
  '2036': '1.00',
  '2037': '1.00',
  '2038': '1.00',
  '2039': '1.00',
  '2040': '1.00',
  '2041': '1.00',
  '2042': '1.00',
  '2043': '1.00',
  '2044': '1.00',
  '2045': '1.00',
  '2046': '1.00',
  '2047': '1.00',
  '2048': '1.00',
  '2049': '1.00',
  '2050': '1.00',
  '2051': '1.00',
  '2052': '1.00',
  '2053': '1.00',
  '2054': '1.00',
  '2055': '1.00',
  '2056': '1.00',
  '2057': '1.00',
  '2058': '1.00',
  '2059': '1.00',
  '2060': '1.00',
  '2061': '1.00',
}

export const battery_yearly_cost_index: any = {
  '2022': '1.00',
  '2023': '0.71',
  '2024': '0.64',
  '2025': '0.59',
  '2026': '0.53',
  '2027': '0.48',
  '2028': '0.44',
  '2029': '0.40',
  '2030': '0.40',
  '2031': '0.40',
  '2032': '0.40',
  '2033': '0.40',
  '2034': '0.40',
  '2035': '0.40',
  '2036': '0.40',
  '2037': '0.40',
  '2038': '0.40',
  '2039': '0.40',
  '2040': '0.40',
  '2041': '0.40',
  '2042': '0.40',
  '2043': '0.40',
  '2044': '0.40',
  '2045': '0.40',
  '2046': '0.40',
  '2047': '0.40',
  '2048': '0.40',
  '2049': '0.40',
  '2050': '0.40',
  '2051': '0.40',
  '2052': '0.40',
  '2053': '0.40',
  '2054': '0.40',
  '2055': '0.40',
  '2056': '0.40',
  '2057': '0.40',
  '2058': '0.40',
  '2059': '0.40',
  '2060': '0.40',
  '2061': '0.40',
}

export const residual_battery_yearly_cost_index: any = {
  '2022': '1.00',
  '2023': '0.71',
  '2024': '0.64',
  '2025': '0.59',
  '2026': '0.53',
  '2027': '0.48',
  '2028': '0.44',
  '2029': '0.40',
  '2030': '0.40',
  '2031': '0.40',
  '2032': '0.40',
  '2033': '0.40',
  '2034': '0.40',
  '2035': '0.40',
  '2036': '0.40',
  '2037': '0.40',
  '2038': '0.40',
  '2039': '0.40',
  '2040': '0.40',
  '2041': '0.40',
  '2042': '0.40',
  '2043': '0.40',
  '2044': '0.40',
  '2045': '0.40',
  '2046': '0.40',
  '2047': '0.40',
  '2048': '0.40',
  '2049': '0.40',
  '2050': '0.40',
  '2051': '0.40',
  '2052': '0.40',
  '2053': '0.40',
  '2054': '0.40',
  '2055': '0.40',
  '2056': '0.40',
  '2057': '0.40',
  '2058': '0.40',
  '2059': '0.40',
  '2060': '0.40',
  '2061': '0.40',
}
